/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PitrRestoreVaultWindows } from '../models/PitrRestoreVaultWindows';

export class PitrRestoreWindowsResponse {
  /**
  * Available PITR restore time ranges grouped by vault.
  */
  'vaults': Array<PitrRestoreVaultWindows>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaults",
      "baseName": "vaults",
      "type": "Array<PitrRestoreVaultWindows>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PitrRestoreWindowsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

